import React, {useEffect, useState} from 'react';
import {DropDownList, DropDownListChangeEvent} from "@progress/kendo-react-dropdowns";
import {SelectModel} from "../../../../../../../app/types/SelectModel";
import {useEquipmentApi} from "../../../../../../../app/api/equipment";
import {isAxiosError} from "axios";
import {toast} from "react-toastify";
import {useAppSelector} from "../../../../../../../app/store";
import {selectCurrentUser} from "../../../../../../../features/authentication/authenticationSliceSelectors";
import {getUserRole} from "../../../../../../../helpers/user";
import {UserRole} from "../../../../../../../app/enums/UserRole";
import {ResponseResultCode} from "../../../../../../../app/enums/ResponseResultCode";
import { useDataHelperApi } from '../../../../../../../app/api/dataHelper';

type EditTransportFuelSelectorProps = {
    disabled: boolean;
    isLoadingPrefilledValue: boolean;
    fuel: string | null;
    shipmentGid: string;
    data: Array<SelectModel>;
    onChange: (ev: DropDownListChangeEvent) => void;
}

const EditTransportFuelSelector: React.FC<EditTransportFuelSelectorProps> = ({
                                                                                           fuel,
                                                                                           onChange,
                                                                                           disabled,
                                                                                           shipmentGid,
                                                                                           data,
                                                                                           isLoadingPrefilledValue,
                                                                                       }) => {
    //const [data, setData] = useState<Array<SelectModel>>([]);
    const user = useAppSelector(selectCurrentUser);

    // useEffect(() => {

    //     (async () => {
    //         try {
    //             const response = await getFuelTree(shipmentGid);
    //             //const response = await getFuelTree("AAG.20240620-0007");

    //             if (response?.status === 200 && response.data?.resultCode === ResponseResultCode.Ok &&
    //                 response.data?.data) {
    //                 setData(response.data.data);
    //             }
    //         } catch (e) {
    //             if (isAxiosError(e)) {
    //                 toast.error(`Unable to get fuel tree: ${e.message}`);
    //             }
    //         }
    //     })();

    //     return () => {
    //         cancel();
    //     }
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, []);

    return (
        <DropDownList data={data}
                      className={'edit-transport-fuel-value'}
                      disabled={disabled || !user}
                      loading={!user || isLoadingPrefilledValue}
                      textField="text"
                      dataItemKey="value"
                      value={fuel !== null ? data.find(e => e.value === fuel) : data.find(e => e.value === "")}
                      onChange={onChange}
        />
    );
};

export default EditTransportFuelSelector;